import {Routes} from "@angular/router";
import {AdminAuthorizedGuard} from "./guards/admin-authorized.guard";
import {UserListViewComponent} from "./views/user-list-view/user-list-view.component";
import {AdminModuleComponent} from "./admin-module.component";
import {EStoreMigrationViewComponent} from "./views/e-store-migration-view/e-store-migration-view.component";
import {EStoreMigrationGuard} from "./guards/estore-migration.guard";

export const adminRoutes: Routes = [
  {
    path: 'administration',
    component: AdminModuleComponent,
    canActivate: [AdminAuthorizedGuard],
    children: [
      {
        path: '',
        canActivateChild: [AdminAuthorizedGuard],
        children: [
          {
            path: 'benutzer',
            component: UserListViewComponent
          },
          {
            path: 'estore-migration',
            component: EStoreMigrationViewComponent,
            canActivate: [EStoreMigrationGuard]
          },
          {
            path: '',
            redirectTo: 'benutzer',
            pathMatch: 'full'
          },
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.ts